import React from "react";
import { ApplicationApi } from "../../../../../../../../../services/Api/Organization/types";
import { AppState } from "../../../utils/types";
import HotelAppModalForm from "../HotelAppForm/HotelModalForm";

interface Props {
	appState: AppState;
	handleUpdateApp: (data: ApplicationApi) => void;
}

const ChartModalForm = ({ appState, handleUpdateApp }: Props) => {
	return <HotelAppModalForm appState={appState} handleUpdateApp={handleUpdateApp} provider="CHART" />;
};

export default ChartModalForm;
